<template>
  <CollapsePanel class="borrow-token-panel" name="repay-token-panel">
    <div class="title" slot="title">还款</div>
    <div class="panel-content" slot="content">
      <Spin fix v-if="loading"></Spin>
      <div class="caption-title">
        预计还款后杠杆率：
        <div class="leverage-ratio" v-if="item.currentRepayLeverage">
          <Progress
            :stroke-width="8"
            :stroke-color="progressBarColor"
            :percent="getLeverageRatio()"
            hide-info
          />
          <div class="cur-borrow-leverage" :style="{ color: progressBarColor }">
            {{ item.currentRepayLeverage }}%
          </div>
          <div class="max-borrow-leverage">
            (max={{ item.maxRepayLeverage }}%)
          </div>
        </div>
        <div v-else>-</div>
      </div>
      <div class="input-operate-container" v-if="!loading">
        <div class="input-and-ratio">
          <div class="input-group">
            <InputToken
              disabled
              v-if="item.borrowTokenInfos"
              v-for="(borrowInfo, borrowInfoIndex) in item.borrowTokenInfos"
              :key="borrowInfo.symbol"
              :tokenSymbol="borrowInfo.symbol"
              v-model="item[`repayTokenValue${borrowInfoIndex}`]"
            />
          </div>
          <Slider
            v-model="slideRatio"
            :tip-format="format"
            @on-change="onSliderChange"
            :show-stops="false"
            :marks="{
              0: '0%',
              50: '50%',
              100: '100%',
            }"
          />
        </div>

        <div class="operate-wrapper">
          <Button
            type="primary"
            @click="onRepay"
            :disabled="isPaybackButtonDisabled"
            >Payback</Button
          >
        </div>
      </div>

      <div v-show="false">{{ refreshCount }}</div>
    </div>
  </CollapsePanel>
</template>

<script>
import CollapsePanel from "../../../components/common/CollapsePanel";
import InputToken from "../../../components/common/InputToken";
import debounce from "lodash/debounce";

export default {
  name: "RepayTokenPanel",
  props: {
    item: {
      type: Object,
    },
    refreshCount: Number,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CollapsePanel,
    InputToken,
  },
  mounted() {},
  data() {
    return {
      slideRatio: 0,
      progressBarColor: "#1BBE6B",
      isPaybackButtonDisabled: true,
    };
  },
  computed: {},
  methods: {
    format(val) {
      return val + "%";
    },

    onSliderChange: debounce(function (value) {
      if (!value) {
        this.$emit("on-reset");
        this.isPaybackButtonDisabled = true;
        return;
      }

      this.isPaybackButtonDisabled = false;
      this.item.repayRatio = value;
      this.$emit("cal-repay");
    }, 500),
    onRepay: function () {
      this.$emit("on-repay");
    },
    getLeverageRatio() {
      if (this.item.currentRepayLeverage >= this.item.maxRepayLeverage) {
        this.progressBarColor = "#F72E54";
        return 100;
      } else {
        this.progressBarColor = "#1BBE6B";
        return (
          (this.item.currentRepayLeverage / this.item.maxRepayLeverage) * 100
        );
      }
    },
  },
  watch: {
    refreshCount: function (newValue) {},
    loading: function (newValue) {
      if (newValue) {
        this.slideRatio = 0;
        this.isPaybackButtonDisabled = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/fonts.scss";
@import "../../../common/colors.scss";

.flex-row {
  display: flex;
}

.title {
  @include fontSize-16;
  @include mediumFont;
  color: #e6e6e6;
}

.panel-content {
  background: #202125;
  border-radius: 16px;
  padding: 20px 16px;
  position: relative;
  overflow: hidden;

  .input-and-ratio {
    min-width: 60%;
  }

  .input-operate-container {
    display: flex;
  }

  .input-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(1, auto);
    grid-column-gap: 16px;
  }

  .operate-wrapper {
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: repeat(1, auto);
    grid-column-gap: 16px;
    margin: 0 0 0 16px;

    button {
      margin: 3px 0 0 0;
    }
  }
}

.caption-title {
  @include fontSize-14;
  @include mediumFont;
  color: #fff;
  display: flex;
  align-items: center;
  margin: 0 0 20px 0;
}

.leverage-ratio {
  min-width: 365px;
  width: 30%;
  display: flex;
  align-items: center;
  margin: 0 0 0 8px;

  .cur-borrow-leverage {
    @include fontSize-14;
    @include boldFont;
    color: #1bbe6b;
    margin: 0 0 0 10px;
  }

  .max-borrow-leverage {
    @include fontSize-12;
    @include mediumFont;
    color: #53545c;
    margin: 0 0 0 8px;
  }
}
</style>
